import React from 'react';
import {withStyles} from '@material-ui/core/styles';

import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';

import i18n from "../../i18n";
import ListItem from "./ListItem";
import Icon from "@material-ui/core/Icon";

const ListGroup = ({classes, group, lifeCycleRates, categoryOptions, intervalUnits}) => (
    <div className={classes.container}>
        {(group.models.length > 0) && (
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell scope="col">{i18n.get('attribute.form.name')}</TableCell>
                        <TableCell scope="col">{i18n.get('attribute.form.unit')}</TableCell>
                        <TableCell scope="col" className={classes.rate}>{i18n.get('attribute.form.rate')}</TableCell>
                        <TableCell scope="col">{i18n.get('attribute.form.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {group.models.map(attribute => (
                        <ListItem
                            intervalUnits={intervalUnits}
                            lifeCycleRates={lifeCycleRates}
                            key={attribute.id}
                            attribute={attribute}
                            categoryOptions={categoryOptions}
                        />
                    ))}
                </TableBody>
            </Table>
        )}

        {Object.values(group.sub).map(subGroup => (
            <ExpansionPanel key={subGroup.name} defaultExpanded={subGroup.expanded || false}>
                <ExpansionPanelSummary
                    expandIcon={<Icon>expand_more</Icon>}
                >
                    <Typography color="inherit">{subGroup.name}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                    <ListGroup
                        intervalUnits={intervalUnits}
                        lifeCycleRates={lifeCycleRates}
                        classes={classes}
                        group={subGroup}
                        categoryOptions={categoryOptions}
                    />
                </ExpansionPanelDetails>
            </ExpansionPanel>
        ))}
    </div>
);


const styles = theme => ({
    container: {
        width: '100%',
    },
    rate: {
        textAlign: "center",
    },
});

export default withStyles(styles)(ListGroup);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Attribute/ListGroup.jsx